module.exports = __webpack_public_path__ + "static/img/image071.f897dbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image071.png
// module id = WeGk
// module chunks = 1